import { useContext } from 'react';
import type { UserDto } from '../features/login/types/UserDto';
import {
	MedeposContext,
	defaultContextValues,
} from '../routes/ContextProvider';

type StorageKeys = {
	role: string;
	organisation: string;
	isAuth: string;
};

export const STORAGE_KEYS: StorageKeys = {
	role: 'role',
	organisation: 'organisation',
	isAuth: 'isAuth',
};

//For anyone that comes across this, this is not the only auth. There are HTTP only cookies managed by the server. This is just client side management.
export function useAuth() {
	const { context, setContext } = useContext(MedeposContext);

	const login = (user: UserDto) => {
		localStorage.setItem(STORAGE_KEYS.role, user.role);
		localStorage.setItem(STORAGE_KEYS.organisation, user.organisation);
		localStorage.setItem(STORAGE_KEYS.isAuth, 'true');

		setContext({
			role: user.role,
			organisation: user.organisation,
			isAuth: true,
		});
	};

	const isAuth = (): boolean => {
		return context.isAuth;
	};

	const getRole = () => {
		return context.role;
	};

	const signOut = () => {
		localStorage.removeItem(STORAGE_KEYS.role);
		localStorage.removeItem(STORAGE_KEYS.organisation);
		localStorage.removeItem(STORAGE_KEYS.isAuth);

		setContext(defaultContextValues);
	};

	return {
		login,
		isAuth,
		signOut,
		getRole,
	};
}
